export enum CUSTOM_NOTE_CONTEXT {
  WEBSHOP = 'WEBSHOP',
  MARKETPLACE = 'MARKETPLACE',
}

export interface CustomNoteLabel {
  text: string;
  useCustomColor: boolean;
  bgColor?: string;
  textColor?: string;
  colorType?: string;
}
